import { ShieldAlert } from 'lucide-react';

/**
 * RUO ("Research Use Only") badge.
 *
 * Sizes: 'sm' (default, compact), 'md' (with full label)
 */
export default function RUOBadge({ size = 'sm', className = '', lang = 'bg' }) {
  const label = size === 'md'
    ? (lang === 'en' ? 'Research Use Only' : 'Само за изследователски цели')
    : 'RUO';
  const tooltip = lang === 'en'
    ? 'Research Use Only — not for medical diagnosis, treatment or clinical decision support.'
    : 'Само за изследователски цели — не за медицинска диагноза, лечение или клинични решения.';

  return (
    <span
      title={tooltip}
      data-testid="ruo-badge"
      className={`inline-flex items-center gap-1 rounded-full border border-amber-600/50 bg-amber-50 dark:bg-amber-950/40 text-amber-800 dark:text-amber-300 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${className}`}
    >
      <ShieldAlert className="w-3 h-3" />
      {label}
    </span>
  );
}
